// src/config/navLinks.js
export const userMenuLinks = [
  { name: "Home", path: "/" },
  { name: "Paramètres", path: "/user/information" },
  { name: "Déconnexion", path: "/logout" }
];

export const mainMenuLinks = [
  { name: "Home", path: "/" },
  {
    name: "Gérer des comptes",
    path: "",
    requiredRoles: ['Manager_UG', 'Manager_INT'],
    submenu: [
      { name: "gérer mon UG", path: "/manager-ug", requiredRoles: ['Manager_UG'] },
      { name: "gérer mon INT", path: "/manager-int", requiredRoles: ['Manager_INT'] }
    ]
  },
  {
    name: "Consulter des contrats",
    requiredRoles: ['Createur', 'Controle', 'Controle_UG', 'Saisie'],
    path: "",
    submenu: [
      { name: "Voir les contrat tous UGs", path: "/contrat/consulter-contrat/all", requiredRoles: ['Controle'] },
      { name: "Voir les contrats UG", path: "/contrat/consulter-contrat/ug", requiredRoles: ['Controle_UG'] },
      { name: "Voir nos contrat", path: "/contrat/consulter-contrat/int", requiredRoles: ['Createur'] },
      { name: "Rechercher un contrat", path: "/contrat/rechercher-contrat", requiredRoles: ['Createur'] }
    ]
  },
  {
    name: "Administration",
    path: "",
    requiredRoles: ['Admin'],
    submenu: [
      { name: "Créer une UG", path: "/admin/creer-ug" },
      { name: "Modifier une UG", path: "/admin/modifier-ug" },
      { name: "Créer un INT", path: "/admin/creer-int" },
      { name: "Modifier un INT", path: "/admin/modifier-int" },
      { name: "Créer un utilisateur", path: "/admin/creer-utilisateur" },
      { name: "Modifier un utilisateur", path: "/admin/modifier-utilisateur" }
    ]
  },
  { name: "Documentations", path: "/documentations" },
];

